// Токен доступа к /promo (один-в-один с Солнышко): страницу нельзя открыть
// напрямую — только по ссылке из баннера с ?k=<token>. Детерминированный (без
// БД): и баннер, и страница считают одинаково. Не криптостойкий — лишь чтобы не
// набрать /promo руками и получить скидку.
export function promoToken(citySlug: string): string {
  const s = `${citySlug}|autopilot-promo-2026`;
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (Math.imul(h, 31) + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h).toString(36);
}
